
export default function BlogGrid() {
  const blogs = [
    {
      id: 1,
      title: 'Employee vs. Contractor: The Math Behind Outsourcing Your Layout & Detailing in 2026',
      excerpt: 'Discover why Vancouver construction firms are converting fixed employee costs into variable project expenses by outsourcing AutoCAD layout and detailing work.',
      date: 'January 15, 2026',
      readTime: '6 min read',
      category: 'Cost Analysis',
      icon: 'ri-money-dollar-circle-line',
      link: '/blog-employee-vs-contractor',
    },
    {
      id: 2,
      title: 'Surging Without Hiring: How Outsourcing Layout Work Helps Vancouver Firms Stay Lean',
      excerpt: 'Learn how Vancouver construction firms use outsourced layout detailing to handle project surges without long-term hiring commitments in the Lower Mainland market.',
      date: 'January 20, 2026',
      readTime: '5 min read',
      category: 'Scalability Strategy',
      icon: 'ri-rocket-line',
      link: '/blog-surge-capacity',
    },
    {
      id: 3,
      title: 'Why Specialized Layout Contractors are Replacing the "Generalist" In-House Drafter',
      excerpt: 'Discover why Vancouver construction firms are choosing specialized AutoCAD experts over generalist drafters to avoid costly rework and site delays.',
      date: 'January 25, 2026',
      readTime: '6 min read',
      category: 'Expertise Matters',
      icon: 'ri-user-star-line',
      link: '/blog-expert-vs-generalist',
    },
    {
      id: 4,
      title: 'Speed to Market: Using Contract Detailing to Hit 2026 Rental Housing Targets',
      excerpt: 'Learn how Vancouver developers use outsourced layout services to accelerate purpose-built rental construction and maximize rental income in BC housing market.',
      date: 'February 1, 2026',
      readTime: '5 min read',
      category: 'Rental Development',
      icon: 'ri-building-line',
      link: '/blog-rental-housing',
    },
    {
      id: 5,
      title: 'Stop Paying for Licenses: The Hidden Savings of Outsourcing Your Construction Tech',
      excerpt: 'Discover how Vancouver contractors eliminate AutoCAD and Bluebeam subscription costs by outsourcing layout work and converting software expenses into project value.',
      date: 'February 5, 2026',
      readTime: '5 min read',
      category: 'Technology Savings',
      icon: 'ri-computer-line',
      link: '/blog-software-costs',
    },
    {
      id: 6,
      title: 'Why Bluebeam Revu Takeoffs Are Replacing Manual Measurements on Vancouver Job Sites',
      excerpt: 'Discover how digital takeoffs using Bluebeam Revu are eliminating costly measurement errors and saving Vancouver contractors thousands per project.',
      date: 'December 15, 2025',
      readTime: '5 min read',
      category: 'Technology',
      icon: 'ri-ruler-line',
      link: '/blog-bluebeam-takeoffs',
    },
    {
      id: 7,
      title: 'The Hidden Cost of "Simple" Layouts: Why Complex Buildings Need Expert Detailing',
      excerpt: 'Learn why seemingly straightforward construction projects in Vancouver require specialized AutoCAD expertise to avoid expensive site delays and rework.',
      date: 'December 20, 2025',
      readTime: '6 min read',
      category: 'Project Planning',
      icon: 'ri-building-2-line',
      link: '/blog-complex-layouts',
    },
    {
      id: 8,
      title: 'From Permit to Pour: How Proper Layout Planning Accelerates Your Construction Timeline',
      excerpt: 'Explore how professional formwork layout services help Vancouver contractors move from permit approval to concrete pour faster than ever.',
      date: 'December 28, 2025',
      readTime: '5 min read',
      category: 'Efficiency',
      icon: 'ri-time-line',
      link: '/blog-lifecycle',
    },
    {
      id: 9,
      title: 'Building on Slopes: Why Vancouver\'s Hillside Projects Demand Specialized Layout Expertise',
      excerpt: 'Understand the unique challenges of sloped site construction in Vancouver and how expert layout services prevent costly foundation errors.',
      date: 'January 5, 2026',
      readTime: '6 min read',
      category: 'Site Challenges',
      icon: 'ri-landscape-line',
      link: '/blog-sloped-sites',
    },
    {
      id: 10,
      title: 'Speed vs. Accuracy: How Professional Layout Services Deliver Both in Vancouver\'s Fast-Paced Market',
      excerpt: 'Learn how Dinari Designs helps Vancouver contractors meet aggressive timelines without sacrificing the precision required for complex formwork.',
      date: 'January 10, 2026',
      readTime: '5 min read',
      category: 'Best Practices',
      icon: 'ri-speed-line',
      link: '/blog-speed-timelines',
    },
    {
      id: 11,
      title: 'The Real ROI of Professional Construction Layout Services in Vancouver',
      excerpt: 'Discover how investing in expert AutoCAD layout and Bluebeam takeoff services delivers measurable returns for Vancouver construction projects.',
      date: 'November 28, 2025',
      readTime: '7 min read',
      category: 'Business Strategy',
      icon: 'ri-line-chart-line',
      link: '/blog',
    },
    {
      id: 12,
      title: 'The Technical Bottleneck: How Small Firms Win Big Contracts in Vancouver',
      excerpt: 'You have the crew, but do you have the drawings? Learn how outsourcing your Senior Detailer role allows a 5-person team to compete like a 50-person firm.',
      date: 'February 10, 2026',
      readTime: '6 min read',
      category: 'Business Growth',
      icon: 'ri-arrow-up-circle-line',
      link: '/blog-technical-bottleneck',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <a
              key={blog.id}
              href={blog.link}
              className="group bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="p-8">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center group-hover:bg-teal-500 transition-colors duration-300">
                    <i className={`${blog.icon} text-2xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <span className="text-xs font-medium text-teal-600 bg-teal-50 px-3 py-1 rounded-full whitespace-nowrap">
                    {blog.category}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-teal-600 transition-colors duration-300 line-clamp-2">
                  {blog.title}
                </h3>

                <p className="text-gray-600 mb-4 line-clamp-3 text-sm leading-relaxed">
                  {blog.excerpt}
                </p>

                <div className="flex items-center justify-between text-sm text-gray-500 pt-4 border-t border-gray-100">
                  <div className="flex items-center">
                    <i className="ri-calendar-line mr-2"></i>
                    <span className="whitespace-nowrap">{blog.date}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line mr-2"></i>
                    <span className="whitespace-nowrap">{blog.readTime}</span>
                  </div>
                </div>
              </div>

              <div className="px-8 pb-6">
                <div className="flex items-center text-teal-600 font-medium group-hover:text-teal-700 cursor-pointer whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
